import React from 'react'
import { TextInput, Checkbox } from '../forms'

interface AgentWorkflowSectionProps {
  isSignedContract: boolean
  agentWorkflowId: string
  presubmitAgentWorkflowId?: string
  agentWorkflowEnabled: boolean
  onAgentWorkflowIdChange: (agentWorkflowId: string) => void
  onPresubmitAgentWorkflowIdChange?: (presubmitAgentWorkflowId: string) => void
  onAgentWorkflowEnabledChange: (agentWorkflowEnabled: boolean) => void
}

export const AgentWorkflowSection = ({
  isSignedContract,
  agentWorkflowId,
  presubmitAgentWorkflowId,
  agentWorkflowEnabled,
  onAgentWorkflowIdChange,
  onPresubmitAgentWorkflowIdChange,
  onAgentWorkflowEnabledChange
}: AgentWorkflowSectionProps) => {
  return (
    <div className="row">
      <div className="col-md-6 form-group mb-3">
        <label>Agent Workflow ID</label>
        <TextInput
          value={agentWorkflowId}
          emptyOk
          onChange={onAgentWorkflowIdChange}
          placeholder="Enter agent workflow ID"
        />
      </div>
      {isSignedContract && (
        <div className="col-md-6 form-group mb-3">
          <label>Pre-Submit Workflow ID</label>
          <TextInput
            value={presubmitAgentWorkflowId}
            emptyOk
            onChange={onPresubmitAgentWorkflowIdChange}
            placeholder="Enter pre-submit workflow ID"
          />
        </div>
      )}
      <div className="col-md-6 form-group mb-3">
        <Checkbox
          label="Agent Workflow Enabled"
          disabled={!agentWorkflowId}
          value={agentWorkflowEnabled}
          onChange={ev => onAgentWorkflowEnabledChange(ev.target.checked)}
        />
      </div>
    </div>
  )
}
